import {
  NAVIGATE,
  SET_HOME_NAV_MOUNTED,
  SET_MAIN_NAV_MOUNTED,
} from "../reducers/actionTypes";

export const actions = {
  navigate: (params) => ({ type: NAVIGATE, params }),
  homeNavMounted: (mounted) => ({ type: SET_HOME_NAV_MOUNTED, mounted }),
  mainNavMounted: (mounted) => ({ type: SET_MAIN_NAV_MOUNTED, mounted }),
};
